import request from '@/utils/request'

// 分页查询商品列表
export function listVideoProduct(data) {
  return request({
    url: '/video/videoProduct/list',
    method: 'get',
    params: data
  })
}

// 查询详情
export function detailVideoProduct(query) {
  return request({
    url: '/video/videoProduct/detail',
    method: 'get',
    params: query
  })
}

// 新增
export function addVideoProduct(data) {
  return request({
    url: '/video/videoProduct/add',
    method: 'post',
    data
  })
}

// 更新
export function updateVideoProduct(data) {
  return request({
    url: '/video/videoProduct/update',
    method: 'post',
    data
  })
}

// 删除
export function deleteVideoProduct(data) {
  return request({
    url: '/video/videoProduct/del',
    method: 'post',
    data
  })
}